import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface IDialogTitleContent {
	iconName: string;
	title: string;
	contents: string[];
	cancelButtonEnabled: boolean;
}
@Component({
	selector: 'copo-dialog-warning',
	templateUrl: './dialog-warning.component.html',
	styleUrl: './dialog-warning.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,
		MatDialogModule,
		TranslateModule,
		MatButtonModule,
		MatIconModule,
	],
})
export class DialogWarningComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IDialogTitleContent,
		private readonly dialogRef: MatDialogRef<DialogWarningComponent>
	) {}

	ngOnInit() {
		this.dialogRef.updateSize('60%');
		this.dialogRef.disableClose = true;
	}
}
